/**
 * Configuración Maestra del Plan de Carrera LIGNUMS
 * Regla base: 10 USD = 1 Punto
 */

export const CAREER_POINTS_RATIO = 10;

export const RANKS = {
    ASSOCIATE: {
        id: 1,
        name: 'ASSOCIATE',
        label: 'Asociado',
        pointsRequired: 500,
        color: '#3dcc85', // Verde (Estabilidad)
        imageKey: 'IMG_ASSOCIATE',
        stone: 'Estabilidad',
        stoneDescription: 'Símbolo de fundamento y permanencia. Soporte del sistema.',
        rewards: ['Pin oficial ASSOCIATE', 'Kit de bienvenida Lignums'],
        requirements: {
            teamRequired: false,
            minSellers: 0,
            minExecutives: 0,
            businessUnitRequired: false
        }
    },
    SENIOR_ASSOCIATE: {
        id: 2,
        name: 'SENIOR ASSOCIATE',
        label: 'Asociado Senior',
        pointsRequired: 1500,
        color: '#0ea5e9', // Azul (Energía)
        imageKey: 'IMG_SENIOR_ASSOCIATE',
        stone: 'Energía',
        stoneDescription: 'Símbolo de energía sostenida y determinación.',
        rewards: ['Pin oficial SENIOR ASSOCIATE', 'Reconocimiento especial'],
        requirements: {
            teamRequired: false,
            minSellers: 0,
            minExecutives: 0,
            businessUnitRequired: false
        }
    },
    EXECUTIVE_PARTNER: {
        id: 3,
        name: 'EXECUTIVE PARTNER',
        label: 'Socio Ejecutivo',
        pointsRequired: 4000,
        color: '#8b5cf6', // Violeta (Claridad)
        imageKey: 'IMG_EXECUTIVE',
        stone: 'Claridad',
        stoneDescription: 'Símbolo de responsabilidad y criterio.',
        rewards: ['Pin oficial EXECUTIVE PARTNER', 'Experiencia Premium'],
        requirements: {
            teamRequired: true,
            minSellers: 1, 
            minExecutives: 0,
            businessUnitRequired: false
        }
    },
    MANAGING_PARTNER: {
        id: 4,
        name: 'MANAGING PARTNER',
        label: 'Socio Manager',
        pointsRequired: 10000,
        color: '#f59e0b', // Ámbar (Equilibrio)
        imageKey: 'IMG_MANAGING',
        stone: 'Equilibrio',
        stoneDescription: 'Símbolo de templanza y liderazgo consciente.',
        rewards: ['Pin oficial MANAGING PARTNER', 'Smartphone Premium'],
        requirements: {
            teamRequired: true,
            minSellers: 10,
            minExecutives: 3,
            businessUnitRequired: false
        }
    },
    DIRECTOR: {
        id: 5,
        name: 'DIRECTOR',
        label: 'Director de Unidad',
        pointsRequired: 30000,
        color: '#ef4444', // Rojo (Autoridad)
        imageKey: 'IMG_DIRECTOR',
        stone: 'Autoridad',
        stoneDescription: 'Símbolo de compromiso y liderazgo firme.',
        rewards: ['Pin oficial DIRECTOR', 'Notebook Premium'],
        requirements: {
            teamRequired: true,
            minSellers: 10,
            minExecutives: 3,
            businessUnitRequired: true
        }
    },
    EXECUTIVE_DIRECTOR: {
        id: 7, 
        name: 'EXECUTIVE DIRECTOR',
        label: 'Director Ejecutivo',
        pointsRequired: 120000,
        color: '#0f172a', // Azul Medianoche (Excelencia)
        imageKey: 'IMG_EXECUTIVE_DIRECTOR',
        stone: 'Claridad Absoluta',
        stoneDescription: 'Símbolo de excelencia y precisión.',
        rewards: ['Pin oficial EXECUTIVE DIRECTOR', 'Vehículo'],
        requirements: {}
    },
    BOARD_PARTNER: {
        id: 8,
        name: 'BOARD PARTNER',
        label: 'Socio del Directorio',
        pointsRequired: 300000,
        color: '#71717a', // Plata/Zinc (Sabiduría)
        imageKey: 'IMG_BOARD',
        stone: 'Sabiduría',
        stoneDescription: 'Símbolo de gobierno y legado.',
        rewards: ['Pin oficial BOARD PARTNER', 'Vivienda'],
        requirements: {}
    }
};

// Helper para obtener el array ordenado de rangos por puntos
export const RANK_LIST = Object.values(RANKS).sort((a, b) => a.pointsRequired - b.pointsRequired);

export default RANKS;